export default __webpack_public_path__ + "static/media/laptop_ptBR.e9d76d46.png";